import { JSONSchema } from "@/types";
import { getModelParams } from "@/components/ModelParameters/utils";
import { usePlayground } from "@/components/Playground/playground-store";
import { useParameters } from "@/components/ModelParameters/store/parameters-store";

const useJSONSchema = () => {
  const playground = usePlayground();
  const parametersStore = useParameters();
  const { models } = parametersStore;
  const metadata = playground.blueprint?.metadata;
  const provider = metadata?.model?.provider;
  const model = metadata?.model;

  if (!provider || !model) {
    return false;
  }
  const modelParams = getModelParams(models, model.name);

  if (!modelParams) {
    return false;
  }

  const hasJSONSchema = Boolean(
    modelParams
      .find(p => p.param_id === "response_format")
      ?.options?.find(o => o.value?.type === "json_schema"),
  );

  if (!hasJSONSchema) {
    return false;
  }

  const schemaFromBlueprint = metadata?.model?.parameters?.response_format?.json_schema;
  const schemaFromParametersStore = parametersStore.JSONSchema;

  // Return existing schema if available, otherwise hasJSONSchema to indicate support.
  // Cohere (and some providers) mark response_format disabled in model config; convertToBlueprintModel
  // omits disabled params, so the schema may only live in the parameters store until synced.
  return (schemaFromBlueprint || schemaFromParametersStore || hasJSONSchema) as
    | JSONSchema
    | boolean;
};

export default useJSONSchema;
